/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { usePlaylistsList } from '@api/hooks';

import SearchableEntitySelect from '../SearchableEntitySelect';

const PlaylistSelect = ({ placeholder = 'Type the name of playlist...', ...props }) => (
  <SearchableEntitySelect
    formatLabel={({ title }) => title}
    useList={usePlaylistsList}
    placeholder={placeholder}
    {...props}
  />
);

export default PlaylistSelect;
